import { style } from 'typestyle'
import { important } from 'csx'
export const f15i = style({ fontSize: important('15px') })
